import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { explainerItems } from "@/mocks/movieContent";

export default function ExplainerSection() {
  const [openSet, setOpenSet] = useState<number[]>([0]);

  const toggle = (index: number) => {
    setOpenSet((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  return (
    <section id="explain" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="讲什么"
          title="解说与讲什么：用大白话回答几个关键问题"
          description="很多人搜索这部影片，其实只是想先弄清楚它到底讲了什么。下面用问答的方式，把最常见的疑问一次说明白。"
          align="center"
          icon="ri-question-line"
        />

        <div className="max-w-3xl mx-auto space-y-3">
          {explainerItems.map((item, index) => {
            const open = openSet.includes(index);
            return (
              <div
                key={item.q}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={open}
                  className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
                >
                  <span className="flex items-start gap-3">
                    <span className="w-6 h-6 shrink-0 mt-0.5 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xs font-semibold font-label">
                      Q
                    </span>
                    <span className="font-heading text-base md:text-lg font-medium text-foreground-950 leading-snug">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 shrink-0 transition-transform duration-300 ${
                      open ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-4 md:px-6 pb-5 pl-[3.25rem] md:pl-[3.75rem]">
                      <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{item.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}